import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CaixaService } from 'app/service/caixa/caixa.service';
import { EventEmitterService } from 'app/service/event-emitter-service';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-relatorio-solicitacao',
  templateUrl: './relatorio-solicitacao.component.html',
  styleUrls: ['./relatorio-solicitacao.component.scss']
})
export class RelatorioSolicitacaoComponent implements OnInit, OnDestroy {

  public solicitacaoId;
  public deData;
  public solicitacao;
  public dateTime;
  public caixas;
  loading = false;

  constructor(
    private caixaService: CaixaService,
    private solicitacaoService: SolicitacaoService,
    private route: ActivatedRoute) {
    EventEmitterService.get("isPrintPage").emit(true);
    
    this.route.params.subscribe(params => this.solicitacaoId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.solicitacaoId), 'pcdoc');
    this.solicitacaoId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
   }

  ngOnInit() {
    this.getSolicitacao(this.solicitacaoId);
    let date = new Date();
    this.dateTime = date.toLocaleString('pt-BR');
  }

  ngOnDestroy() {
    EventEmitterService.get("isPrintPage").emit(false);
  }

  getSolicitacao(solicitacaoId) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      this.solicitacao = data;
      this.caixas = this.solicitacao.caixas;
      console.log(this.solicitacao);
    }, err => {
      console.error(err);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/relatorio-solicitacao/relatorio-solicitacao.component.ts